/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.building\":\"Leilighetsbygg\"}");